<template>
  <span v-html="highlightedText"></span>
</template>

<script>
export default {
  props: [
    'searchKeyword',
    'textItem',
    'frontItem',
    'backItem',
    'accentStyle',
    'accentColor'
  ],
  computed: {
    highlightedText () {
      if (!this.searchKeyword) {
        return this.textItem
      }
      const indices = this.findIndices(this.textItem.toLowerCase() + (this.backItem || '').toLowerCase(), this.searchKeyword.toLowerCase(), (this.frontItem || '').toLowerCase())
      if (!indices) {
        return this.textItem
      }
      let result = ''
      for (let i = 0; i < this.textItem.length; i++) {
        if (!indices[i]) {
          result += this.textItem.charAt(i).replace(/ /g, '&nbsp;')
        } else {
          result += this.highlightStyle + this.textItem.substring(i, indices[i]).replace(/ /g, '&nbsp;') + '</mark>'
          i = indices[i] - 1
        }
      }
      return result
    },
    highlightStyle () {
      let color = this.accentColor || '#ff8400'
      if (this.accentStyle === 'background') {
        return `<mark style="color: #fff; background-color: ${color};">`
      }
      return `<mark style="color: ${color}; background-color: transparent;">`
    }
  },
  methods: {
    findIndices (textItem, searchKeyword, frontItem = '') {
      if ((frontItem + textItem).indexOf(searchKeyword) === -1) {
        return null
      }
      let indices = {}
      const len = (frontItem + textItem).length
      for (let i = 0; i !== len; i++) {
        const index = (frontItem + textItem).substring(i, len).indexOf(searchKeyword)
        if (index === -1) {
          return indices
        }
        const position = i + index - frontItem.length + searchKeyword.length
        if (position > -1) {
          indices[Math.max(0, i + index - frontItem.length)] = position
        }
        i = i + index + searchKeyword.length - 1
      }
      return indices
    }
  },
  data () {
    return {
    }
  }
}
</script>
